class util {

    setToken = (token) => {
        window.localStorage.setItem('authorization', token);

    }
    setIsStaff = (staff) => {
        window.localStorage.setItem('user', staff);

    }

    getIsStaff = () => {
        return window.localStorage['user'] || '';
    }


    getToken = () => {
        return window.localStorage['authorization'] || '';
    }

    isLogged = () => {
        if (typeof window.localStorage['authorization'] !== "undefined" && window.localStorage['authorization'] !== '') {
            return true;
        }
        return false;
    }

    logout = (e) => {
        if (e) e.preventDefault();
        window.localStorage.clear();

        window.location.replace("https://leadfuzionlists.com/logout")
    }
}
export default new util();